import { render, staticRenderFns } from "./ModalVisualizarAgendamentoColetivo.vue?vue&type=template&id=7c5fa2b5&scoped=true"
import script from "./ModalVisualizarAgendamentoColetivo.vue?vue&type=script&lang=ts"
export * from "./ModalVisualizarAgendamentoColetivo.vue?vue&type=script&lang=ts"
import style0 from "./ModalVisualizarAgendamentoColetivo.vue?vue&type=style&index=0&id=7c5fa2b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5fa2b5",
  null
  
)

export default component.exports